module.exports = __webpack_public_path__ + "static/img/线路LDI.7ebacda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/instructionsIimags/线路LDI.jpg
// module id = HTj/
// module chunks = 1